export const sportsImagesAssetsUrl: string = 'https://static-assets.lvbet.com/images/';
